import React from 'react'

const Exclamation = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">

      <g clipPath="url(#clip0_250_2207)">
        <path d="M5.675 0.1825C5.79213 0.0656638 5.95081 3.51487e-05 6.11625 0L13.8838 0C14.0492 3.51487e-05 14.2079 0.0656638 14.325 0.1825L19.8175 5.675C19.9343 5.79213 20 5.95081 20 6.11625V13.8838C20 14.0492 19.9343 14.2079 19.8175 14.325L14.325 19.8175C14.2079 19.9343 14.0492 20 13.8838 20H6.11625C5.95081 20 5.79213 19.9343 5.675 19.8175L0.1825 14.325C0.0656638 14.2079 3.51487e-05 14.0492 0 13.8838L0 6.11625C3.51487e-05 5.95081 0.0656638 5.79213 0.1825 5.675L5.675 0.1825ZM6.375 1.25L1.25 6.375V13.625L6.375 18.75H13.625L18.75 13.625V6.375L13.625 1.25H6.375Z"
              fill="#151F31"
        />
        <path d="M8.7525 13.7499C8.7525 13.5858 8.78483 13.4232 8.84765 13.2715C8.91047 13.1199 9.00255 12.9821 9.11862 12.866C9.23469 12.7499 9.37249 12.6579 9.52415 12.5951C9.67581 12.5322 9.83835 12.4999 10.0025 12.4999C10.1667 12.4999 10.3292 12.5322 10.4809 12.5951C10.6325 12.6579 10.7703 12.7499 10.8864 12.866C11.0025 12.9821 11.0945 13.1199 11.1574 13.2715C11.2202 13.4232 11.2525 13.5858 11.2525 13.7499C11.2525 14.0814 11.1208 14.3994 10.8864 14.6338C10.652 14.8682 10.334 14.9999 10.0025 14.9999C9.67098 14.9999 9.35304 14.8682 9.11862 14.6338C8.8842 14.3994 8.7525 14.0814 8.7525 13.7499ZM8.875 6.24365C8.85836 6.08595 8.87505 5.92652 8.924 5.77569C8.97295 5.62486 9.05307 5.486 9.15915 5.36814C9.26523 5.25027 9.39491 5.15602 9.53977 5.09151C9.68462 5.02699 9.84143 4.99365 10 4.99365C10.1586 4.99365 10.3154 5.02699 10.4602 5.09151C10.6051 5.15602 10.7348 5.25027 10.8409 5.36814C10.9469 5.486 11.0271 5.62486 11.076 5.77569C11.125 5.92652 11.1416 6.08595 11.125 6.24365L10.6875 10.6274C10.6728 10.7996 10.594 10.96 10.4667 11.0769C10.3394 11.1939 10.1728 11.2587 10 11.2587C9.82716 11.2587 9.66062 11.1939 9.53331 11.0769C9.406 10.96 9.3272 10.7996 9.3125 10.6274L8.875 6.24365Z"
              fill="#151F31"
        />
      </g>
      <defs>
        <clipPath id="clip0_250_2207">
          <rect
            width="20"
            height="20"
            fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export default Exclamation